import { RouteType } from "../../../types/RouteType";
import RootStore from "../../../stores/RootStore";

const scheduleGeneratorRoute: RouteType = {
    name: "Schedule Generator (AI)",
    path: "/scheduling/ai-generator/:jobId?",
    defaultParams: {
        jobId: null,
    },
    layout: "/app",
    viewportCard: {
        header: {
            component: () => import("./ScheduleGenerator.Header"),
            title: "AI Schedule Generator",
            color: "primary",
            enableRefreshButton: true,
            enableBackButton: true,
        },
        body: {
            component: () => import("./ScheduleGenerator.Container"),
            grayBackground: false,
        },
    },
    group: 'Scheduling',
  requiresAuth: true,
    requiresPermission: false,
    beforeEnter: async ({ rootStore, params }) => {
        try {
            const scheduleGeneratorStore = rootStore.scheduleGeneratorStore;
            if (scheduleGeneratorStore && typeof scheduleGeneratorStore === 'object' && 'initializeGenerator' in scheduleGeneratorStore) {
                await (scheduleGeneratorStore as any).initializeGenerator(params.jobId);
            }
            return true;
        } catch (error) {
            console.error("Failed to initialize schedule generator:", error);
            return false;
        }
    },
    onParamsChange: async ({ rootStore, params, previousParams }) => {
        if (params.jobId !== previousParams?.jobId) {
            const scheduleGeneratorStore = rootStore.scheduleGeneratorStore;
            if (scheduleGeneratorStore && typeof scheduleGeneratorStore === 'object' && 'initializeGenerator' in scheduleGeneratorStore) {
                await (scheduleGeneratorStore as any).initializeGenerator(params.jobId);
            }
        }
    },
    dialogs: [
        {
            name: "optimizationParametersDialog",
            component: () => import("./OptimizationParametersDialog"),
            title: "Schedule Optimization Parameters",
            onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
                const scheduleGeneratorFormStore = rootStore.scheduleGeneratorFormStore;
                if (scheduleGeneratorFormStore && typeof scheduleGeneratorFormStore === 'object' && 'save' in scheduleGeneratorFormStore) {
                    await (scheduleGeneratorFormStore as any).save();
                    return true;
                }
                return false;
            },
            onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
                const scheduleGeneratorFormStore = rootStore.scheduleGeneratorFormStore;
                return scheduleGeneratorFormStore && typeof scheduleGeneratorFormStore === 'object' && 'isValid' in scheduleGeneratorFormStore
                    ? (scheduleGeneratorFormStore as any).isValid
                    : false;
            },
            cancelButton: true,
            height: 600,
        },
        /*
        {
            name: "constraintsDialog",
            component: () => import("./ConstraintsDialog"),
            title: "Schedule Constraints",
            onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
                const scheduleGeneratorFormStore = rootStore.scheduleGeneratorFormStore;
                if (scheduleGeneratorFormStore && typeof scheduleGeneratorFormStore === 'object' && 'save' in scheduleGeneratorFormStore) {
                    await (scheduleGeneratorFormStore as any).save();
                    return true;
                }
                return false;
            },
            onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
                const scheduleGeneratorFormStore = rootStore.scheduleGeneratorFormStore;
                return scheduleGeneratorFormStore && typeof scheduleGeneratorFormStore === 'object' && 'isValid' in scheduleGeneratorFormStore
                    ? (scheduleGeneratorFormStore as any).isValid
                    : false;
            },
            cancelButton: true,
        },
        {
            name: "approveScheduleDialog",
            component: () => import("./ApproveScheduleDialog"),
            title: "Approve Generated Schedule",
            onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
                const scheduleGeneratorFormStore = rootStore.scheduleGeneratorFormStore;
                if (scheduleGeneratorFormStore && typeof scheduleGeneratorFormStore === 'object' && 'save' in scheduleGeneratorFormStore) {
                    await (scheduleGeneratorFormStore as any).save();
                    return true;
                }
                return false;
            },
            onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
                const scheduleGeneratorFormStore = rootStore.scheduleGeneratorFormStore;
                return scheduleGeneratorFormStore && typeof scheduleGeneratorFormStore === 'object' && 'isValid' in scheduleGeneratorFormStore
                    ? (scheduleGeneratorFormStore as any).isValid
                    : false;
            },
            cancelButton: true,
        },
        */
    ],
};

export default scheduleGeneratorRoute;
